// extracted by mini-css-extract-plugin
module.exports = {"tags":"br_fY","tags__item":"br_fZ"};